var _defs, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDolphin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3350,
    height: 1650,
    viewBox: "0 0 886.35415 436.56251",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,139.56252)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#40729a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.34187222,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 8.12598419,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    d: "m 213.86944,135.26353 c 0,0 -15.44018,15.44015 -20.19103,28.50491 -4.7508,13.06479 -8.31393,26.12959 -1.18768,27.31732 7.12621,1.18764 13.17088,-12.85507 32.06804,-16.03409 12.93689,-2.17629 49.88367,-4.15701 49.88367,-4.15701 z",
    id: "path832"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#db393f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.34187222,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 8.12598419,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    d: "M 29.774968,58.06262 C 28.587259,44.997854 68.969265,59.250318 96.286491,41.434738 123.60376,23.619106 127.16689,3.4281286 127.16689,3.4281286 l 83.13942,-9.5016602 -29.69267,57.0099196 -62.94841,23.754104 -46.320568,-1.18772 z",
    id: "path830"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 1,
      fill: "#ff6167",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.77063608,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 8.12598419,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "path836",
    cx: 102.46807,
    cy: 81.945869,
    rx: 47.797413,
    ry: 13.664415,
    transform: "matrix(0.96804067,-0.25079326,0.26527426,0.964173,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#adc8ce",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.34187222,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 8.12598419,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    d: "m 186.55221,2.2403989 c 0,0 -1.33927,22.4514001 -39.19434,45.1328211 -31.06444,18.61276 -80.235914,21.192385 -117.582902,10.6894 0,0 -2.375397,26.129521 66.511523,26.129521 61.760719,0 51.071379,8.313973 103.330449,51.071389 46.87192,38.34974 129.46001,85.5148 199.53465,109.26897 70.07468,23.75411 193.89591,17.14168 239.16223,1.72703 82.60624,-28.13009 101.95438,-53.79697 101.95438,-53.79697 L 589.18455,207.71364 361.14498,110.32169 262.56538,-20.325996 Z",
    id: "path828"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#418cc7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.34187222,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 8.12598419,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    d: "m 220.99566,-115.34251 c -96.37248,1.69073 -115.20752,64.136136 -129.459983,70.074691 -14.252439,5.938523 -57.009895,-4.750846 -67.699243,4.750815 -10.689359,9.501649 -13.064766,26.129531 0,32.0680756 13.064787,5.9385337 65.323856,29.6926374 111.644376,23.7541144 33.50761,-4.29585 58.1976,-16.6279032 74.8255,-11.8770574 16.6279,4.7508353 36.8189,8.3139204 49.88367,53.4467824 13.06478,45.132809 49.88365,74.825489 49.88365,74.825489 0,0 -19.00329,32.06804 -2.37544,74.8255 16.62791,42.75744 36.81894,65.32381 45.13287,65.32381 8.31392,0 1.18772,-24.94184 7.12624,-54.63447 5.93852,-29.69268 20.19099,-41.56974 20.19099,-41.56974 0,0 96.35197,37.30359 186.58507,48.26424 86.41459,10.49681 116.0895,6.61752 173.53484,-31.44718 0,0 17.62433,-23.89637 30.59541,-17.8717 12.97099,6.02464 39.82573,25.24063 66.67146,19.6565 26.84566,-5.58413 38.78713,-15.37195 36.73695,-22.19685 -2.05021,-6.82502 -17.17925,-3.5204 -26.05449,-8.29516 -8.87511,-4.77475 -24.47192,-36.05351 -43.13035,-40.36964 -18.65849,-4.31615 -30.03339,-0.8992 -30.03339,-0.8992 0,0 2.85842,-12.20859 1.47022,-24.004265 -2.39641,-20.362432 -16.39249,-29.799575 -18.67202,-41.516206 -2.27952,-11.716606 8.86154,-32.42525 1.46563,-36.404219 -7.396,-3.978977 -50.61163,33.805614 -46.96082,62.472222 3.65078,28.666618 21.17631,45.724478 17.88076,55.395368 -3.29558,9.671 -35.74584,60.09856 -92.357,39.59153 C 592.76823,161.6793 547.61483,115.07251 553.55342,90.130675 559.49198,65.188852 651.34783,72.274988 655.69615,65.188852 660.04446,58.102695 639.85496,11.633361 553.55339,-0.13500833 501.29435,-7.2612405 470.414,3.4281599 451.41066,-2.5103947 432.40739,-8.4489284 400.33932,-34.578481 344.51713,-72.585049 312.10423,-94.653407 260.34555,-116.03287 220.99566,-115.34251 Z",
    id: "path826"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      fill: "#fcfcfc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 5.34187222,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 8.12598419,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "path834",
    cx: 253.60905,
    cy: -26.88039,
    r: 15.956868
  }), /*#__PURE__*/React.createElement("circle", {
    r: 12.279945,
    cy: -26.88039,
    cx: 253.60905,
    id: "circle838",
    style: {
      opacity: 1,
      fill: "#2a241e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.11095047,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 8.12598419,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cy: -173.14803,
    cx: 168.80548,
    id: "circle840",
    style: {
      opacity: 1,
      fill: "#fcfcfc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.25247955,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 8.12598419,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    rx: 6.3077245,
    ry: 7.1772404,
    transform: "matrix(0.80560388,0.59245454,-0.63858157,0.76955414,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolphin);
export default __webpack_public_path__ + "static/media/dolphin.adf13b0623a410a632fd98f530aa2239.svg";
export { ForwardRef as ReactComponent };